export default __webpack_public_path__ + "static/media/invoice01.9693a120.png";